<template>
  <div>
    <Row class="changePwdModal">
      <Col span="12">
      <Form span="12" ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
        <FormItem label="原密码：" prop="oldPass">
          <Input v-model.trim="formValidate.oldPass"></Input>
        </FormItem>
        <FormItem label="新密码：" prop="newPass">
          <Input v-model.trim="formValidate.newPass"></Input>
        </FormItem>
        <FormItem label="确认：" prop="confirmPass">
          <Input v-model.trim="formValidate.confirmPass"></Input>
        </FormItem>
        <div class="butnWarp">
          <Button type="primary" class="topBtn tobBtnN" :loading='saveloading' @click="handleSubmit('formValidate')">修改密码</Button>
        </div>
      </Form>
      </Col>
    </Row>
  </div>
</template>
<script>
export default {
  data() {
    const oldPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入原始密码"));
      }
      callback();
    };
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (this.checkPass(value) < 2) {
        callback(new Error("请输入8-16位的字母、数字、特殊符号任意两种以上的组合"));
      } else {
        if (this.formValidate.confirmPass !== "") {
          // 对第三个密码框单独验证
          this.$refs.formValidate.validateField("confirmPass");
        }
        callback();
      }
    };
    const validatePassCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.formValidate.newPass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      saveloading: false,
      formValidate: {
        oldPass: "",
        newPass: "",
        confirmPass: ""
      },
      ruleValidate: {
        oldPass: [{ validator: oldPass, trigger: "blur", type: "number" }],
        newPass: [
          { validator: validatePass, trigger: "blur" },
          { type: "string", min: 8, max: 20, message: "请输入8-16位的字母、数字、特殊符号任意两种以上的组合" }
        ],
        confirmPass: [
          { validator: validatePassCheck, trigger: "blur" },
          { type: "string", min: 8, max: 20, message: "请输入8-16位的字母、数字、特殊符号任意两种以上的组合" }
        ]
      }
    };
  },
  methods: {
    checkPass(s) {
      if (s.length < 8 || s.length > 16 || s == '') {
        return 0;
      }
      var ls = 0;
      if (s.match(/([a-z])+/)) {
        ls++;
      }
      if (s.match(/([0-9])+/)) {
        ls++;
      }
      if (s.match(/([A-Z])+/)) {
        ls++;
      }
      if (s.match(/[^a-zA-Z0-9]+/)) {
        ls++;
      }
      return ls
    },
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        this.saveloading = true
        console.log(valid, '表格内数据', this.md5(this.formValidate.oldPass))
        if (valid) {
          //console.log(this.$store.state.user.userId)
          let data = {
            oldPassword: this.formValidate.oldPass.trim(),
            // this.md5(
            //    this.formValidate.oldPass
            // ),
            password: this.formValidate.newPass.trim(),
            // this.md5(
            //    this.formValidate.newPass 
            // ),
            id: localStorage.getItem('userId')
          };
          console.log(data, 'kkkkk')
          this.axios
            .post(this.GLOBAL + "api/auth/user/pass/update", data)
            .then(res => {
              this.saveloading = false
              if (res.data.code == 1000) {
                this.$Message.success("修改成功");
                window.location.href = localStorage.getItem("hostUrl")//localStorage.getItem('hostName');//localStorage.getItem("hostUrl")
                this.axios.defaults.headers.common["token"] = '123';
                this.$refs.formValidate.resetFields();
              } else {
                this.$Message.warning(res.data.msg);
              }
            }).catch(e => {
              this.saveloading = false
              let msg = e.msg || "网络异常";
              this.$Message.error(msg);
            });
        } else {
          this.saveloading = false
          this.$Message.error("表单验证失败!");
        }
      });
    }
  }
};
</script>
<style lang="less" scope>
.changePwdModal {
  margin-left: 200px;
  padding-top: 80px;
  .ivu-form .ivu-form-item-label {
    font-size: 14px;
  }
  .ivu-input {
    height: 36px;
  }
  .butnWarp {
    width: 100%;
    text-align: center;
  }
  .tobBtnN {
    margin-bottom: 20px;
  }
}
.ivu-form-item-content {
  // text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/view/myinfo/changepassword/changepassword.vue